import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import {t} from '../../../common/getTranslations';
import {Maybe, TicketKind} from '../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {Dialog} from '../Dialog';

export function ReceiveFreeTicketDialog({
  open,
  isMobile,
  ticketKind,
  title,
  contentTitle,
  highlight,
  ticketExpireAt,
  handleConfirm,
}: {
  open: boolean;
  isMobile: boolean;
  ticketKind: TicketKind;
  title: string;
  contentTitle: string;
  highlight: string;
  ticketExpireAt?: Maybe<string>;
  handleConfirm: () => void;
}) {
  return (
    <Dialog
      isOpen={!!open}
      isMobile={isMobile}
      isUsingScrollBlock={!isMobile}
      {...putTiaraObjectProps({
        click: {
          layer1: '이용권수령팝업',
          imp_id: 'popup',
          imp_provider: 'service',
        },
        customProps: {
          popup_type: '이용권수령팝업',
          event_ticket_type: ticketKind === TicketKind.Rent ? '대여' : '소장',
        },
        viewimp_contents: {
          imp_id: 'popup',
          imp_provider: 'service',
          imp_type: 'vimp',
          layer1: '이용권수령팝업',
        },
      })}
      onInView={target => {
        aggregateAndSendLog({
          targetElem: target as HTMLElement,
          actionType: 'ViewImp',
          actionName: '팝업_노출',
          customProps: {
            user_action: 'imp',
          },
        });
      }}
      onClose={handleConfirm}
    >
      <Dialog.Dimmed />
      <Dialog.List>
        <Dialog.Image imageType={StaticImageType.ModalGiftStatic} />
        <Dialog.Title className="font-medium1-bold">{title}</Dialog.Title>
        <Dialog.Label>
          {t('contenthome_gift_popup_message', {
            values: {
              title: contentTitle,
              value: highlight,
            },
          })}
          {ticketExpireAt && (
            <>
              <br />
              <br />
              {t('contenthome_gift_popup_message_expiration_date', {
                values: {
                  value: format(
                    parseISO(ticketExpireAt),
                    t('date_formatter_short_year_time_dot')
                  ),
                },
              })}
            </>
          )}
        </Dialog.Label>
      </Dialog.List>
      <Dialog.BottomCombination>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('이용권수령팝업_닫기_클릭', e, handleConfirm)
          }
        >
          {t('common_confirm_button')}
        </Dialog.Button>
      </Dialog.BottomCombination>
    </Dialog>
  );
}
